export default __webpack_public_path__ + "img/receiving-log.0f9891.svg";